import CompleteProject from "assets/images/profile/Complet Projects.svg";
import RateIcon from "assets/images/profile/Rate.svg";
import WorkExperianceIcon from "assets/images/profile/Work Experiance.svg";
import perhourIcon from "assets/images/profile/perhour.svg";
import { _axios } from "interceptor/http-config";
import { HttpRequestInterceptor } from "interceptor/http-request.interceptor";
import { enqueueSnackbar } from "notistack";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useMutation, useQuery, useQueryClient } from "react-query";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { servicesStore } from "store/servicesStore";
export const useServiceProvicerProfile = () => {
  const { t } = useTranslation("index");
  const location = useLocation();
  const queryParameters = new URLSearchParams(location.search);
  const [servicesName, subServicesName, serviceProvider] = servicesStore(
    (state) => [
      state.serviceProvider,
      state.servicesName,
      state.subServicesName,
    ]
  );

  const [favoriteStatus, setFavoriteStatus] = useState({});
  const [loadingFavorite, setLoadingFavorite] = useState(false);
  const queryClient = useQueryClient();
  const favoriteToggle = useMutation(
    async (id) => {
      // Send the update to the server
      return _axios.get(`user/toggle-favourite/${id}`).then((response) =>
        enqueueSnackbar(response.data.message, {
          variant: "success",
          autoHideDuration: 3000,
          anchorOrigin: { vertical: "bottom", horizontal: "right" },
        })
      );
    },
    {
      onMutate: async (id) => {
        await queryClient.cancelMutations(""); // Cancel any pending mutations for this key
        return id; // Pass the id as context for the onSettled function
      },
      onError: (error, variables, context) => {
        if (
          error.response &&
          error.response.data &&
          error.response.data.message
        ) {
          const { message } = error.response.data;
          Object.keys(message).forEach((field) => {
            const errorMessages = message[field];
            alert(`${field}: ${errorMessages.join(", ")}`);
            window.location.reload();
          });
        }
      },
      onSettled: (id, error, result) => {
        // Handle success or error cases and clear loading state
        if (!error) {
          queryClient.invalidateQueries(["favourite"]);
        } else {
          // If there's an error, revert the optimistic update
          const updatedFavoriteStatus = { ...favoriteStatus };
          updatedFavoriteStatus[id] = !updatedFavoriteStatus[id];
          setFavoriteStatus(updatedFavoriteStatus);
        }
        setLoadingFavorite(false);
      },
      onSuccess: (response) => {},
    }
  );

  const handleFavorite = async (id) => {
    setLoadingFavorite(true);
    try {
      await favoriteToggle.mutateAsync(id);
      refetch();
    } catch (error) {
      console.error("Async mutation error:", error);
    }
  };
  const allQueryParameters = {};
  for (const [key, value] of queryParameters.entries()) {
    allQueryParameters[key] = value;
  }

  const param = useParams();
  const [subServicesID, setSubServicesID] = useState();
  const [subServicesIDLoading, setsubServicesIDLoading] = useState(false);
  const {
    data: servicesProviderProfile,
    isLoading: servicesProviderProfileLoading,
    refetch,
  } = useQuery(
    ["services-provider-profile", `id-${param.id}`],
    async () => {
      return _axios
        .get(
          `/user/service-providers/profile/${param.id}`,
          {
            headers: {
              ...HttpRequestInterceptor(),
            },
          },
          setsubServicesIDLoading(true)
        )
        .then((res) => {
          setsubServicesIDLoading(false);
          return res.data;
        });
    },
    {}
  );
  const params = useParams();
  const hanldeSubServices = (item) => {
    setSubServicesID(item);
    navigate(`/service-provider/profile/${item}/${params.id}`);
  };
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  useEffect(() => {
    if (subServicesID) {
      setsubServicesIDLoading(true);
    }
  }, [subServicesID]);
  const details = [
    {
      icon: WorkExperianceIcon,
      data: servicesProviderProfile?.service_provider.work_experience,
      text: t("Work Experience"),
    },
    {
      icon: CompleteProject,
      data: servicesProviderProfile?.service_provider.completed_project,
      text: t("Completed Projects"),
    },
    {
      icon: RateIcon,
      data: servicesProviderProfile?.service_provider.rate,
      text: t("User Review"),
    },
    {
      icon: perhourIcon,
      data: servicesProviderProfile?.service_provider.rate,
      text: t("Per Hour"),
    },
  ];
  const servicesProviderProfileData =
    servicesProviderProfile?.service_provider?.sub_services || [];
  const [currentIndex, setCurrentIndex] = useState(0);

  const itemsToShow = servicesProviderProfileData.slice(
    currentIndex,
    currentIndex + 3
  );

  const showNextItems = () => {
    setCurrentIndex((prevIndex) => prevIndex + 3);
  };
  const navigate = useNavigate();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return {
    t,
    details,
    navigate,
    itemsToShow,
    currentIndex,
    servicesName,
    showNextItems,
    handleFavorite,
    serviceProvider,
    subServicesName,
    loadingFavorite,
    hanldeSubServices,
    subServicesIDLoading,
    servicesProviderProfile,
    servicesProviderProfileLoading,
    servicesProviderProfileData,
  };
};
